export const INTEGER_REGEX = /^[0-9]*$/
export const DECIMAL_REGEX = /^[0-9]*\.?[0-9]*$/
export const NON_DIGIT_REGEX = /[^\d]/g
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const FULL_NAME_REGEX = /^[A-Za-zÀ-ÿ' .-]+$/
export const PHONE_US_REGEX = /^\d{10}$/
export const ZIP_CODE_US_REGEX = /^\d{5}(-\d{4})?$/
export const ZIP_CODE_CA_REGEX = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/
export const URL_REGEX = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/i
export const HTTP_PROTOCOL_REGEX = /^https?:\/\//i
